import './EndOrder.css'; // CSS

function EndOrder({onSucesss, onClose}) {
    return (
        <div className="end-order" onClick={onClose}>
            <div className="end-order__inner" onClick={(e) => e.stopPropagation()}>
                <h2 className="end-order__title">
                    Falta pouco ...
                </h2>

                <p className="end-order__text">
                    Você será direcionado para o WhatsApp para finalizar a compra.
                </p>

                <div className="end-order__footer">
                    <span className="orange-button-light" onClick={onClose}>
                        Cancelar
                    </span>
                    
                    <span className="white-transparent-button" onClick={onSucesss}>
                        Enviar pedido
                    </span>
                </div>
            </div>
        </div>
    );
}

export default EndOrder;